export const LANG = {
  zhTW: 'zh-TW',
  enUS: 'en-US',
}
